module.exports = __webpack_public_path__ + "static/media/checkbox-checked.701f886f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/checkbox-checked.svg
// module id = 2554
// module chunks = 7